// @ts-nocheck
// CRA -> Vite: use import.meta.env instead of process.env. Both the legacy CRA
// name and the Vite-style name resolve here so an existing .env file with
// REACT_APP_API_V keeps working when copied over as VITE_API_V.
// Default is "2" to match the v1 app's shipped .env (REACT_APP_API_V=2) —
// the live API only exposes /api/v2/*; /api/v1/* returns 404.
const API_VERSION =
  import.meta.env.VITE_API_V ||
  import.meta.env.REACT_APP_API_V ||
  "2";
const API_BASE = `/v${API_VERSION}`;

// WebRTC call quality (RTCPeerConnection.getStats). Ported from origin/main-dev
// — these 6 constants are used by CallQualityReport + CallQualityMetricsPanel
// + AgentCallQualityModal on the /dashboard/call-quality route.
export const API_CALL_QUALITY_SUMMARY = `${API_BASE}/call-quality/summary`;
export const API_CALL_QUALITY_BY_CALL = (callSid) =>
  `${API_BASE}/call-quality/calls/${encodeURIComponent(callSid)}`;
export const API_CALL_QUALITY_CALLS = `${API_BASE}/call-quality/calls`;
export const API_CALL_QUALITY_METRICS = `${API_BASE}/call-quality/metrics`;
export const API_CALL_QUALITY_MY_METRICS = `${API_BASE}/call-quality/me/metrics`;
export const API_CALL_QUALITY_AGENT_METRICS = (agentId) =>
  `${API_BASE}/call-quality/agents/${encodeURIComponent(agentId)}/metrics`;

export const API_CALL_TRANSCRIPTS = `${API_BASE}/call-transcripts`;
export const API_CALL_TRANSCRIPTS_EXISTS = `${API_BASE}/call-transcripts/exists`;
export const API_CALL_TRANSCRIPT_BY_TRACE = (traceId) =>
  `${API_BASE}/call-transcripts/by-trace/${encodeURIComponent(traceId)}`;

// User
export const API_USERS_SIGNUP = `${API_BASE}/users/signup`;
export const API_GOOGLE_DRIVE_CONNECT = `${API_BASE}/google/drive/connect`;
export const API_GOOGLE_DRIVE_FREQUENCY = `${API_BASE}/google/drive/frequency`;
export const API_SIGNUP_EMAIL_SEND_CODE = `${API_BASE}/users/signup-email/send-code`;
export const API_SIGNUP_EMAIL_VERIFY_CODE = `${API_BASE}/users/signup-email/verify-code`;
export const API_USERS_SIGNIN = `${API_BASE}/users/signin`;
export const API_USERS_LIST = `${API_BASE}/users`;
export const API_USERS_PROFILE = `${API_BASE}/users/:id`;
export const API_USER_NUMBER_VOICE_PLANS = `${API_BASE}/users/:id/numbers`;
export const API_USER_HIERARCHY = `${API_BASE}/users/:id/hierarchy`;
export const API_SWITCH_USER = `${API_BASE}/users/switch-user`;
export const API_USER_DELETE = `${API_BASE}/users/delete`;
export const API_USER_LOGOUT = `${API_BASE}/users/logout`;
export const API_USER_BULK_LOGOUT = `${API_BASE}/users/bulk-logout`;
export const API_USER_BULK_STATUS = `${API_BASE}/users/bulk-status`;
export const API_USER_LOGIN_AS = `${API_BASE}/users/login-as`;
export const API_USER_SESSION_REFRESH = `${API_BASE}/users/session/refresh`;
export const API_USER_LOGOUT_FROM = `${API_BASE}/users/logout-from`;
export const API_USER_STATUS_UPDATE = `${API_BASE}/users`;
export const API_USER_BREAK_UPDATE = `${API_BASE}/users/:id/break`;
export const API_USER_PASSWORD_RESET_MAIL= `${API_BASE}/users/password-reset-mail`;
export const API_VERIFY_OTP = `${API_BASE}/users/verify-otp`;
export const API_RESET_PASSWORD = `${API_BASE}/users/reset-password`;
export const API_VERIFY_EMAIL = `${API_BASE}/users/verify-email`;
export const API_RESEND_EMAIL_VERIFICATION = `${API_BASE}/users/resend-email-verification`;
export const API_GET_USER = `${API_BASE}/users`;


//queue operation(call-group)

export const CALL_GROUP_REMOVE_AGENT = `${API_BASE}/agent-group/remove-agent`;
export const CALL_GROUP_TOGGLE_AGENT = `${API_BASE}/agent-group/toggle-agent`;
export const CALL_GROUP_ADD_AGENT = `${API_BASE}/agent-group`;

// Call Strategies Master
export const API_CALL_STRATEGIES_MASTER_LIST = `${API_BASE}/strategies-master`;

export const API_CAMPAIGN_OPTIONS = `${API_BASE}/campaign-options`;

//voice-plan
export const API_VOICE_PLAN_LIST = `${API_BASE}/voice-plan`;
export const API_VOICE_PLAN_CREATE = `${API_BASE}/voice-plan/create`;
export const API_VOICE_PLAN_EDIT = `${API_BASE}/voice-plan/update`;
export const API_VOICE_PLAN_NUMBER_EDIT = `${API_BASE}/voice-plan/edit`;
export const API_VOICE_PLAN_DELETE = `${API_BASE}/voice-plan/delete`;
export const API_VOICE_PLAN_GET_BY_ID = `${API_BASE}/voice-plan`;


// Company
export const API_COMPANY_LIST = `${API_BASE}/companies`;
export const API_COMPANY_CREATE = `${API_BASE}/companies`;
export const API_COMPANY_UPLOAD_LOGO = `${API_BASE}/companies/upload-logo`;
export const API_COMPANY_PROFILE = `${API_BASE}/companies/:id`;
/** Lightweight balance for header wallet (company admin / reseller). */
export const API_COMPANY_WALLET_CREDITS = `${API_BASE}/companies/credits`;
export const API_PARENT_COMPANY_LICENCE = `${API_BASE}/companies/parent-licence`;
export const API_COMPANY_DELETE = `${API_BASE}/companies/delete/:id`;
export const API_COMPANY_CONVERT_TO_ACTUAL = `${API_BASE}/companies/convert-to-actual/:id`;
export const API_COMPANY_DEMO_SUMMARY = `${API_BASE}/companies/:id/demo-summary`;
export const API_COMPANY_MY_ASSETS_VISIBILITY = `${API_BASE}/companies/my-assets-visibility`;
export const API_COMPANY_ASSETS_VISIBILITY_ELIGIBILITY = `${API_BASE}/companies/assets-visibility-eligibility`;

export const API_MEDIA_STORAGE_USAGE = `${API_BASE}/media-storage/usage`;
export const API_MEDIA_STORAGE_DELETE_RECORDING = `${API_BASE}/media-storage/recordings/:id`;
export const API_MEDIA_STORAGE_DELETE_VOICEMAIL = `${API_BASE}/media-storage/voicemails/:id`;

export const API_DELETED_FILES = `${API_BASE}/deleted-files`;
export const API_DELETED_FILE_TYPES = `${API_BASE}/deleted-files/types`;
export const API_RECORDINGS_LIST = `${API_BASE}/recordings`;
export const API_COMPANY_LICENCE = `${API_BASE}/companies/:id/licence`;
export const API_DEMO_OVERALL_ANALYTICS = `${API_BASE}/companies/demo-overall-analytics`;
export const API_COMPANY_SWITCH_DEFAULT_USER = `${API_BASE}/companies/:id/switch-to-default-user`;
export const API_CALL_CENTRE_SWITCH_DEFAULT_USER = `${API_BASE}/call-centres/:id/switch-to-default-user`;

// Call Centres
export const API_CALL_CENTRE_LIST = `${API_BASE}/call-centres`;
export const API_CALL_CENTRE_SPEND_ANALYTICS = `${API_BASE}/call-centres/spend-analytics`;
export const API_CALL_CENTRE_SPEND_ANALYTICS_DAILY = `${API_BASE}/call-centres/spend-analytics/daily`;
export const API_CALL_CENTRE_SPEND_ANALYTICS_DETAIL = `${API_BASE}/call-centres/:id/spend-analytics`;
export const API_CALL_GROUP_SPEND_ANALYTICS = `${API_BASE}/call-centres/call-group-spend-analytics`;
export const API_CALL_CENTRE_CREATE = `${API_BASE}/call-centres`;
export const API_CALL_CENTRE_PROFILE = `${API_BASE}/call-centres/:id`;
export const API_CALL_CENTRE_USERS_LIST = `${API_BASE}/call-centres/:id/users`;
export const API_CALL_CENTRE_LICENCE = `${API_BASE}/call-centres/:id/licence`;
export const API_PARENT_CALL_CENTER_LICENCE = `${API_BASE}/companies/parent-licence`;
export const API_CALL_CENTRE_DELETE = `${API_BASE}/call-centres/delete/:id`;

export const API_CALL_CENTRE_ASSIGN_PBX = `${API_BASE}/call-centres/:id/pbx`;
export const API_CALL_CENTRE_ADMIN_ALERT = `${API_BASE}/call-centres/admin-alert`;
export const API_CALL_CENTRE_CREDITS = `${API_BASE}/call-centres/credits`;

// Trunks
export const API_TRUNKS_LIST = `${API_BASE}/trunks`;
export const API_TRUNKS_CREATE = `${API_BASE}/trunks`;
export const API_TRUNKS_EDIT = `${API_BASE}/trunks/:id`;
export const API_TRUNKS_DELETE = `${API_BASE}/trunks/delete`;

// Codecs
export const API_CODECS_LIST = `${API_BASE}/codecs`;


// Manage Groups
export const API_MANAGE_GROUP_CREATE = `${API_BASE}/groups`; 
export const API_MANAGE_GROUP_LISTING = `${API_BASE}/groups`;  
export const API_MANAGE_GROUP_DELETE = `${API_BASE}/groups/delete`; 
export const API_MANAGE_GROUP_UPDATE = (id) => `${API_BASE}/groups/${id}`;
export const API_GET_COMPANY_GROUP = (id) => `${API_BASE}/groups/getByGroupId/${id}`;
export const API_BULK_GROUP_ADD = `${API_BASE}/groups/bulk-add`;
export const API_BULK_GROUP_DELETE = `${API_BASE}/groups/bulk-delete`;
export const API_GROUP_MEMBERS = (id) => `${API_BASE}/groups/${id}/users`;



// Manage Locations
export const API_MANAGE_LOCATIONS_CREATE = `${API_BASE}/locations`;          
export const API_MANAGE_LOCATIONS_LIST = `${API_BASE}/locations`;            
export const API_MANAGE_LOCATIONS_UPDATE = (id) => `${API_BASE}/locations/${id}`;
export const API_GET_COMPANY_LOCATION = (id) => `${API_BASE}/locations/getByLocationId/${id}`;
export const API_MANAGE_LOCATIONS_DELETE = `${API_BASE}/locations/delete`;
export const API_BULK_LOCATION_ADD = `${API_BASE}/locations/bulk-add`;
export const API_BULK_LOCATION_DELETE = `${API_BASE}/locations/bulk-delete`;



//Manage Dialer
export const API_MANAGE_DIALER_CREATE = `${API_BASE}/voice-dialers`;
export const API_MANAGE_DIALER_LISTING = `${API_BASE}/voice-dialers`;
export const API_MANAGE_DIALER_DETAIL = (id) => `${API_BASE}/voice-dialers/${id}`;
export const API_MANAGE_DIALER_UPDATE = (id) => `${API_BASE}/voice-dialers/${id}`;
export const API_MANAGE_DIALER_DELETE = `${API_BASE}/voice-dialers/delete`;



//Country Codes
export const API_COUNTRY_CODES_LIST = `${API_BASE}/country-codes`;

// Country Code Directions Master (SuperAdmin)
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST = `${API_BASE}/country-code-directions-master`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_CREATE = `${API_BASE}/country-code-directions-master`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_UPDATE = (id) => `${API_BASE}/country-code-directions-master/update/${id}`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_DELETE = (id) => `${API_BASE}/country-code-directions-master/delete/${id}`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_SINGLE = (id) => `${API_BASE}/country-code-directions-master/${id}`;
export const API_COUNTRY_CODE_DIRECTIONS_MASTER_AVAILABLE_COUNTRIES = `${API_BASE}/country-code-directions-master/available-countries`;

// User Country Code Directions (assigned per company / call-centre)
export const API_USER_COUNTRY_CODE_DIRECTIONS_ME = `${API_BASE}/user-country-code-directions/me`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_COMPANY = (companyId) => `${API_BASE}/user-country-code-directions/company/${companyId}`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_CALL_CENTRE = (callcenterId) => `${API_BASE}/user-country-code-directions/call-centre/${callcenterId}`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT = (agentId) => `${API_BASE}/user-country-code-directions/agent/${agentId}`;
export const API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT_IDS = `${API_BASE}/user-country-code-directions/agents/bulk`;

//Numbers
export const API_TO_GET_REMOVE_NUMBERS = `${API_BASE}/numbers/remove`;


// Numbers
export const API_NUMBERS_UPLOAD = `${API_BASE}/numbers/upload-numbers`;
export const API_NUMBERS_CREATE = `${API_BASE}/numbers/`;
export const API_NUMBERS_LIST = `${API_BASE}/numbers`;
export const API_SCOPED_NUMBERS_LITE = `${API_BASE}/numbers/scoped-lite`;
export const API_NUMBER_CHANNEL_CONSUMPTION = `${API_BASE}/numbers/:id/channel-consumption`;
export const API_NUMBER_DELETE = `${API_BASE}/numbers/delete`;
export const API_NUMBER_SET_DEMO = `${API_BASE}/numbers/set-demo`;
export const API_NUMBER_EDIT = `${API_BASE}/numbers/:id`;
export const API_DID_NUMBERS = `${API_BASE}/numbers/did`;
export const API_AVAILABLE_DID_NUMBERS = `${API_BASE}/numbers/did/available`;
export const API_NUMBER_STATUS = `${API_BASE}/numbers/number-status`;
export const API_BULK_ASSIGN_DID = `${API_BASE}/numbers/bulk/assign-did`;
export const API_INDIVIDUAL_ASSIGN_DID = `${API_BASE}/numbers/individual/assign-did`;
export const API_NUMBER_FILE_LIST = `${API_BASE}/number-filelist/`;
export const API_NUMBER_FILE_LIST_DELETE = `${API_BASE}/number-filelist/delete`;
export const API_NUMBER_STATUS_CHANGE = `${API_BASE}/numbers/status-change`;
export const API_NUMBER_EDIT_BULK = `${API_BASE}/numbers/update-bulk`;
export const API_DID_MAPPING = `${API_BASE}/numbers/did-mapping`;
export const API_TO_ALLOCATE_NUMBERS = `${API_BASE}/numbers/to-allocate`;
export const API_ALLOCATED_NUMBERS = `${API_BASE}/numbers/allocated`;
export const API_REMOVE_NUMBERS = `${API_BASE}/numbers/remove`;
export const API_INBOUND_ROUTING = `${API_BASE}/numbers/inbound-routing`;
export const API_INBOUND_ROUTING_CLEAR = `${API_BASE}/numbers/inbound-routing/clear`;
export const API_INBOUND_ROUTING_REMOVE = `${API_BASE}/numbers/inbound-routing/remove`;
export const API_CALL_CENTRE_DEFAULT_CLI = `${API_BASE}/numbers/call-centre/default-cli`;

// Agents
export const API_AGENTS_LIST = `${API_BASE}/agents/`;
// Logged-in agent turns their own Auto answer on/off (agents.auto_pick_enabled + activity log).
export const API_AGENT_AUTO_ANSWER = `${API_BASE}/agents/me/auto-answer`;
export const AGENT_GROUP_CREATE = `${API_BASE}/agents/`;
export const API_AGENT_DELETE = `${API_BASE}/agents/delete`;
export const API_AGENT_UPDATE = `${API_BASE}/agents`;
export const API_AGENT_BREAK_ADD = `${API_BASE}/agents/break`;
export const API_AGENT_REALTIME_CALL_CENTRES = `${API_BASE}/agents/real-time/call-centres`;
export const API_AGENT_PARENT_ID = `${API_BASE}/agents/parent/:id/:user`;
export const API_AGENT_BULK_LOGOUT = `${API_BASE}/agents/bulk-logout`;
export const API_AGENT_BULK_UPLOAD = `${API_BASE}/agents/bulk-upload`;
export const API_AGENT_SCHEDULE = `${API_BASE}/agents/agent_schedule`;
export const API_AGENT_FILE_LIST = `${API_BASE}/agent-filelist/`;
export const API_AGENT_FILE_LIST_DELETE = `${API_BASE}/agent-filelist/delete`;
export const API_AGENT_FILE_LIST_DOWNLOAD = `${API_BASE}/agent-filelist/download`;
export const API_AGENTS_GROUP_OWNERS = `${API_BASE}/agents/group_owners/:id`;
export const API_AGENT_IDLE_STATS = `${API_BASE}/agents/idle-stats`;
export const API_AGENT_IDLE_STATS_GET = `${API_BASE}/agents/idle-stats`;
export const API_AGENT_AVAILABLE_INBOUND_NUMBERS = `${API_BASE}/agents/available-inbound-numbers`;
export const API_AGENT_MY_ASSIGNED_CLIS = `${API_BASE}/agents/me/assigned-clis`;

export const API_AGENT_MY_INTERNAL_AGENTS = `${API_BASE}/agents/me/internal-agents`;
// On-call Transfer flow: available agents to transfer to
export const API_AGENT_TRANSFER_AVAILABLE = `${API_BASE}/agents/transfer/available-agents`;
export const API_AGENT_CLI_FALLBACK = `${API_BASE}/numbers/agent-cli/:agentId`;
export const API_AGENT_AVAILABLE_INBOUND_NUMBERS_BY_ID = `${API_BASE}/agents/:id/available-inbound-numbers`;
export const API_AGENT_CLI_ALLOCATIONS_SYNC = `${API_BASE}/agents/:id/cli-allocations/sync`;
export const API_AGENT_APPROVED_PROMPTS = `${API_BASE}/agents/:id/approved-prompts`;
// Mobile-profile dialer
export const API_AGENT_MOBILE_DIAL = `${API_BASE}/agents/mobile-dial`;
export const API_AGENT_OUTBOUND_VOICE_PLAN_CHECK = `${API_BASE}/agents/outbound-voice-plan-check`;
export const API_AGENT_MOBILE_HANGUP = `${API_BASE}/agents/mobile-hangup`;

export const API_AGENT_VOICEMAIL = `${API_BASE}/agents/voicemail`;
// Hold / Unhold active call — :id = SIP Call-ID
export const API_AGENT_CALL_HOLD = `${API_BASE}/agents/calls/:id/hold`;
export const API_AGENT_CALL_UNHOLD = `${API_BASE}/agents/calls/:id/unhold`;
export const API_AGENT_CALL_MUTE = `${API_BASE}/agents/calls/:id/mute`;
export const API_AGENT_CALL_UNMUTE = `${API_BASE}/agents/calls/:id/unmute`;
// Transfer active call to another agent — :id = Channel-ID
export const API_AGENT_CALL_TRANSFER = `${API_BASE}/agents/calls/:id/transfer`;

export const API_AGENT_CONFERENCE_CREATE = `${API_BASE}/agents/conference`;
export const API_AGENT_CONFERENCE_ADD = `${API_BASE}/agents/conference/:id/add`;

// Team Lead snoop (barge / whisper / monitor) — start :id = agent's Channel-ID (agentCallId)
export const API_AGENT_SNOOP_START = `${API_BASE}/agents/calls/:id/snoop`;
// Stop snoop — :id = listenerAgentConferenceId returned by start
export const API_AGENT_SNOOP_STOP = `${API_BASE}/agents/conferences/:id/snoop`;

// Incoming Summary
export const API_INCOMING_SUMMARY_LIST = `${API_BASE}/incoming-summary/`;
export const API_INCOMING_SUMMARY_DATE_RANGE_LIST = `${API_BASE}/incoming-summary/date-range`;

// Outcoming Summary
export const API_OUTCOMING_SUMMARY_LIST = `${API_BASE}/outcoming-summary/`;

// Download Report
export const DOWNLOAD_REPORT = `${API_BASE}/download-report/`;
export const DOWNLOAD_REPORT_CAMPAIGN = `${API_BASE}/download-report/campaign`;
export const DOWNLOAD_REPORT_CDR = `${API_BASE}/download-report/cdr`;
export const CDR_REPORT = `${API_BASE}/cdr-reports/cdr/`;
export const CDR_TRACE_REPORT = `${API_BASE}/cdr-reports/cdr/trace`;
export const CDR_TRACE_BATCH_REPORT = `${API_BASE}/cdr-reports/cdr/trace-batch`;

// Agent Groups
export const API_AGENT_GROUPS_LIST = `${API_BASE}/agent-group/`;
export const API_AGENT_GROUP_DELETE = `${API_BASE}/agent-group/delete`;
export const API_AGENT_GROUP_EXTENSION = `${API_BASE}/extension`;
export const API_AGENT_GROUP_STRATEGY = `${API_BASE}/call-stratergy`;
export const API_AGENT_GROUP_UPDATE = `${API_BASE}/agent-group/update`;
export const API_AGENT_GROUP_ASSIGNED_AGENTS = `${API_BASE}/agent-group/:id/assigned-agents`;

export const API_AGENT_GROUP_AVAILABLE_INBOUND_NUMBERS = `${API_BASE}/agent-group/:id/available-inbound-numbers`;
export const API_AGENT_GROUP_CLI_ALLOCATIONS_SYNC = `${API_BASE}/agent-group/:id/cli-allocations/sync`;
export const API_AGENT_GROUP_APPROVED_PROMPTS = `${API_BASE}/agent-group/:id/approved-prompts`;

export const API_SINGLE_AGENT_GROUP = `${API_BASE}/agent-group/:id`;
//incoming-report
export const API_INCOMING_REPORT_BY_DID_LIST = `${API_BASE}/incoming-report/get-report`;
export const API_INCOMING_REPORT_TRACE_BATCH = `${API_BASE}/incoming-report/get-report/trace-batch`;
export const API_OUTGOING_REPORT_BY_DID_LIST = `${API_BASE}/outgoing-report/get-report`;
export const API_ALL_INCOMING_REPORT = `${API_BASE}/incoming-report/get-report/incoming`;


//download-report


// Extensions
export const API_EXTENSION = `${API_BASE}/extension`;
export const API_EXTENSION_NEXT_AVAILABLE = `${API_BASE}/extension/next-available`;
export const API_EXTENSION_BULK_CREATE = `${API_BASE}/extension/bulk-create`;

// Manage Queues
export const API_QUEUES = `${API_BASE}/queue`;
export const API_QUEUE_DELETE = `${API_BASE}/queue/delete`;
export const API_QUEUE_UPDATE = `${API_BASE}/queue/`;

// IVR
export const API_IVR_CREATE = `${API_BASE}/call-centres/:cid/ivr`;
export const API_IVR_LIST = `${API_BASE}/call-centres/:cid/ivr`;
export const API_IVR_DELETE = `${API_BASE}/call-centres/:cid/ivr/delete`;
export const API_IVR_EDIT = `${API_BASE}/call-centres/:cid/ivr/:id`;
export const API_IVR_SETTINGS = `${API_BASE}/ivr/settings`;
export const API_IVR_VIEW = `${API_BASE}/call-centres/:cid/ivr/:id`;
// Draft autosave (status=8) — separate from the validated create/update above
export const API_IVR_DRAFT_CREATE = `${API_BASE}/call-centres/:cid/ivr/draft`;
// Same endpoint for both cases — an already-published IVR's edit-draft
// (Redis) and a still-unfinished IVR's draft (flows_json) both autosave
// through this one route; the backend decides which store to use.
export const API_IVR_DRAFT_UPDATE = `${API_BASE}/call-centres/:cid/ivr/draft/:id`;

// Languages / Prompts
export const API_GET_LANGUAGES = `${API_BASE}/language`;
export const API_CREATE_PROMPTS = `${API_BASE}/prompt`;
export const API_BULK_CREATE_PROMPTS = `${API_BASE}/prompt/bulk`;
export const API_EDIT_PROMPT_LANGUAGE_FILE = `${API_BASE}/prompt`; 
export const API_GET_PROMPTS = `${API_BASE}/prompt`;
export const API_PROMPT_ACTIVE_LIST = `${API_BASE}/prompt`;

// MOH (Music On Hold) Management
export const API_MOH = `${API_BASE}/moh`;
export const API_MOH_CREATE = `${API_BASE}/moh`;
export const API_MOH_LIST = `${API_BASE}/moh`;
export const API_MOH_ACTIVE = `${API_BASE}/moh/active`;
export const API_MOH_UPDATE_STATUS = `${API_BASE}/moh/:id`;
export const API_MOH_DELETE = `${API_BASE}/moh/delete`;
export const API_MOH_SET_DEFAULT = `${API_BASE}/moh/:id/set-default`;

// Operators
export const API_OPERATORS_LIST = `${API_BASE}/operators`;
export const API_OPERATORS_DELETE = `${API_BASE}/operators/delete`;

// Flow Variables / Operators (IVR Conditional node)
export const API_FLOW_VARIABLES_LIST = `${API_BASE}/flow-variables`;
export const API_FLOW_OPERATORS_LIST = `${API_BASE}/flow-operators`;

// Timezones
export const API_TIMEZONES_LIST = `${API_BASE}/timezones`;

// Data Center
export const API_DATA_CENTER_LIST = `${API_BASE}/data-center`;
export const API_DATA_CENTER_CREATE = `${API_BASE}/data-center/create`;
export const API_DATA_CENTER_EDIT = `${API_BASE}/data-center/:id`;
export const API_DATA_CENTER_DELETE = `${API_BASE}/data-center/delete`;

// States
export const API_STATES_LIST = `${API_BASE}/states`;

// Cities
export const API_CITIES_LIST = `${API_BASE}/city`;

// Server Management
export const API_SERVER_MANAGEMENT_CREATE = `${API_BASE}/server-management/create`;
export const API_SERVER_MANAGEMENT_LIST = `${API_BASE}/server-management`;
export const API_SERVER_MANAGEMENT_DELETE = `${API_BASE}/server-management/delete`;
export const API_SERVER_MANAGEMENT_EDIT = `${API_BASE}/server-management/:id`;

// Module
export const API_MODULE_CREATE = `${API_BASE}/module`;
export const API_MODULE_LIST = `${API_BASE}/module`;
export const API_MODULE_DELETE = `${API_BASE}/module/delete`;
export const API_MODULE_EDIT = `${API_BASE}/module/:id`;
export const API_ACL_SETTING_CREATE = `${API_BASE}/acl-settings/create`;
export const API_ACL_SETTING_LIST = `${API_BASE}/acl-settings`;
export const API_ACL_SETTING_EDIT = `${API_BASE}/acl-settings/:id`;
export const API_PARENT_ACL_SETTINGS = `${API_BASE}/acl-settings/parent`;
export const API_ACL_SETTING_DELETE = `${API_BASE}/acl-settings/delete`;
export const API_ACL_SETTING_HISTORY = `${API_BASE}/acl-settings/history`;
export const API_ACL_FREEZE_PASSWORD = `${API_BASE}/acl-settings/freeze-password`;
export const API_ACL_FREEZE_PASSWORD_REVEAL = `${API_BASE}/acl-settings/freeze-password/reveal`;
export const API_ACL_LOCK_AUDIT = `${API_BASE}/acl-settings/lock-audit`;
export const API_ACL_SETTING_LOCK = `${API_BASE}/acl-settings/:id/lock`;
export const API_ACL_SETTING_CONTACT_CUSTOM_FIELDS_USAGE = `${API_BASE}/acl-settings/:id/contact-custom-fields-usage`;

//remark stattus
export const API_REMARK_STATUS_CREATE = `${API_BASE}/remark-status/create`;
export const API_REMARK_STATUS_LIST = `${API_BASE}/remark-status`;
export const API_REMARK_STATUS_DELETE = `${API_BASE}/remark-status/delete`;
export const API_REMARK_STATUS_EDIT = `${API_BASE}/remark-status/:id`;

//remark
export const API_REMARK_CREATE = `${API_BASE}/remarks/create`;
export const API_REMARK_LIST = `${API_BASE}/remarks`;

// Agent_Announcement
export const API_AGENT_ANNOUNCEMENT_LIST = `${API_BASE}/agent-announcements`;
export const API_AGENT_ANNOUNCEMENT_CREATE = `${API_BASE}/agent-announcements/create`;
export const API_AGENT_ANNOUNCEMENT_EDIT = `${API_BASE}/agent-announcements/update/:id`;
export const API_AGENT_ANNOUNCEMENT_DELETE = `${API_BASE}/agent-announcements/delete`;
export const API_AGENT_ANNOUNCEMENT_SINGLE = `${API_BASE}/agent-announcements/:id`;

// Journey Operation
export const API_JOURNEY_OPERATION_LIST = `${API_BASE}/user-journey`;
export const API_JOURNEY_OPERATION_FILTERS = `${API_BASE}/user-journey/filters`;

// Export Operation
export const API_LIST_EXPORT = `${API_BASE}/export/:model`;

// User Credits
export const API_CREDITS = `${API_BASE}/credits/:id`;
export const API_CREDITS_GET = `${API_BASE}/credits`;

//DID History
export const API_ALLOCATED_DID = `${API_BASE}/did-allocate-history/`;
export const API_REMOVE_DID = `${API_BASE}/did-remove-history`;

// Company Credits
export const API_COMPANY_CREDITS = `${API_BASE}/credits/company/:id`;
export const API_VOICE_CREDITS_LOGS = `${API_BASE}/voice-credits-logs`;
export const API_TTS_CREDITS_LOGS = `${API_BASE}/tts-credits-logs`;
export const API_AI_AGENT_CREDITS_LOGS = `${API_BASE}/ai-agent-credits-logs`;

// Outgoing Calls
export const API_OUTGOING_CALLS = `${API_BASE}/outgoing-calls`;

// Voice Campaigns
export const API_VOICE_CAMPAIGNS_LIST = `${API_BASE}/voice-campaigns`;
export const API_VOICE_CAMPAIGNS_LIVE = `${API_BASE}/voice-campaigns/live`;
export const API_VOICE_CAMPAIGNS_SUMMARY = `${API_BASE}/voice-campaigns/summary`;
export const API_VOICE_CAMPAIGNS_NUMBERS = `${API_BASE}/voice-campaigns/:id/numbers`;
export const API_VOICE_CAMPAIGNS_CREATE = `${API_BASE}/voice-campaigns`;
export const API_VOICE_CAMPAIGNS_GET_ONE = `${API_BASE}/voice-campaigns/:id`;
export const API_VOICE_CAMPAIGNS_CHECK_NAME = `${API_BASE}/voice-campaigns/check-name`;
export const API_VOICE_CAMPAIGNS_CONTACTS = `${API_BASE}/voice-campaigns/:id/contacts`;
export const API_VOICE_CAMPAIGNS_CONTACT_GROUPS = `${API_BASE}/voice-campaigns/:id/contact-groups`;
export const API_VOICE_CAMPAIGNS_BASES = `${API_BASE}/voice-campaigns/:id/bases`;
export const API_VOICE_CAMPAIGNS_BASE_STATUS = `${API_BASE}/voice-campaigns/:id/bases/:baseId/status`;
export const API_VOICE_CAMPAIGNS_BASE = `${API_BASE}/voice-campaigns/:id/bases/:baseId`;
export const API_VOICE_CAMPAIGNS_CALL_GROUP_AGENTS = `${API_BASE}/voice-campaigns/:id/call-groups/:groupId/agents`;
export const API_VOICE_CAMPAIGNS_AGENTS = `${API_BASE}/voice-campaigns/:id/agents`;
export const API_VOICE_CAMPAIGNS_CALL_GROUPS = `${API_BASE}/voice-campaigns/:id/call-groups`;
export const API_VOICE_CAMPAIGNS_DISPOSITION_SUBMISSIONS = `${API_BASE}/voice-campaigns/:id/disposition-submissions`;
export const API_VOICE_CAMPAIGNS_UPDATE = `${API_BASE}/voice-campaigns/:id`;
export const API_VOICE_CAMPAIGNS_EDIT = `${API_BASE}/voice-campaigns/:id/edit`;

export const API_CAMPAIGN_REPORT = `${API_BASE}/campaign-report/:id`;

// Voice Base (contact list files for campaigns)
export const API_VOICE_BASE_LIST = `${API_BASE}/voice-base`;
export const API_VOICE_BASE_UPLOAD = `${API_BASE}/voice-base/upload`;
export const API_VOICE_BASE_NUMBERS = `${API_BASE}/voice-base/:id/numbers`;

// Break
export const API_BREAK_LIST = `${API_BASE}/breaks`;
export const API_BREAK_UPDATE = `${API_BASE}/breaks/:id`;
export const API_BREAK_CREATE = `${API_BASE}/breaks`;
export const API_BREAK_DELETE = `${API_BASE}/breaks/delete`;
export const API_BREAK_GET_ONE = `${API_BASE}/breaks/:id`;

// Webhook
export const API_WEBHOOK_LIST = `${API_BASE}/webhook`;
export const API_WEBHOOK_UPDATE = `${API_BASE}/webhook/:id`;
export const API_WEBHOOK_CREATE = `${API_BASE}/webhook`;
export const API_WEBHOOK_DELETE = `${API_BASE}/webhook/delete`;
export const API_WEBHOOK_GET_ONE = `${API_BASE}/webhook/:id`;
export const API_WEBHOOK_REQUEST_PARAMETERS = `/v2/webhook/request-parameters`;


// Sms Webhook
export const API_SMSWEBHOOK_LIST = `${API_BASE}/sms-webhook`;
export const API_SMSWEBHOOK_UPDATE = `${API_BASE}/sms-webhook/:id`;
export const API_SMSWEBHOOK_CREATE = `${API_BASE}/sms-webhook`;
export const API_SMSWEBHOOK_DELETE = `${API_BASE}/sms-webhook/delete`;
export const API_SMSWEBHOOK_GET_ONE = `${API_BASE}/sms-webhook/:id`;

// Api Webhook
export const API_APIWEBHOOK_LIST = `${API_BASE}/api-webhook`;
export const API_APIWEBHOOK_UPDATE = `${API_BASE}/api-webhook/:id`;
export const API_APIWEBHOOK_CREATE = `${API_BASE}/api-webhook`;
export const API_APIWEBHOOK_DELETE = `${API_BASE}/api-webhook/delete`;
export const API_APIWEBHOOK_GET_ONE = `${API_BASE}/api-webhook/:id`;
export const API_APIWEBHOOK_REQUEST_PARAMETERS_LIST = `${API_BASE}/api-webhook-request-parameters`;

// Contact Groups
export const API_CONTACT_GROUP_LIST = `${API_BASE}/contact-groups`;
export const API_CONTACT_GROUP_CREATE = `${API_BASE}/contact-groups`;
export const API_CONTACT_GROUP_DELETE = `${API_BASE}/contact-groups/:id`;
export const API_CONTACT_GROUP_RENAME = `${API_BASE}/contact-groups/:id`;
export const API_CONTACT_GROUP_BULK_DELETE = `${API_BASE}/contact-groups/bulk-delete`;
export const API_CONTACT_GROUP_MEMBER_UPLOAD = `${API_BASE}/contact-groups/import/:id`;

// Contact Group Members
export const API_CONTACT_GROUP_MEMBERS_LIST = `${API_BASE}/contact-group-member`;
export const API_CONTACT_GROUP_MEMBERS_UPDATE = `${API_BASE}/contact-group-member/:id`;
export const API_CONTACT_GROUP_MEMBERS_CREATE = `${API_BASE}/contact-group-member`;
export const API_CONTACT_GROUP_MEMBERS_DELETE = `${API_BASE}/contact-group-member/delete`;
export const API_CONTACT_GROUP_MEMBERS_BULK_DELETE = `${API_BASE}/contact-group-member/bulk-delete`;
export const API_CONTACT_GROUP_MEMBERS_GET_ONE = `${API_BASE}/contact-group-member/:id`;
export const API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP = `${API_BASE}/contact-group-member/contact-group/:id`;
export const API_CONTACT_GROUP_MEMBERS_DELETE_ALL = `${API_BASE}/contact-group-member/contact-group/:id/delete-all`;
export const API_CONTACT_GROUP_MEMBERS_UPLOAD = `${API_BASE}/contact-group-member/upload/file`;
export const API_ALL_CONTACTS_LIST = `${API_BASE}/contact-group-member/all/members`;
export const API_ALL_CONTACTS_PAGED = `${API_BASE}/contact-group-member/all/paged`;
export const API_ALL_CONTACTS_GROUP_OPTIONS = `${API_BASE}/contact-group-member/all/group-options`;
export const API_CONTACT_GROUP_MEMBER_BY_NUMBER = `${API_BASE}/contact-group-member/get-member-by-number/:number`;

// Contact custom field templates
export const API_CONTACT_CUSTOM_FIELD_TEMPLATES = `${API_BASE}/contact-custom-field-templates`;
export const API_CONTACT_CUSTOM_FIELD_TEMPLATES_DELETE = `${API_BASE}/contact-custom-field-templates/delete`;
export const API_CONTACT_CUSTOM_FIELD_TEMPLATES_RENAME = `${API_BASE}/contact-custom-field-templates/rename`;
export const API_CONTACT_CUSTOM_FIELDS_ACCESS = `${API_BASE}/contact-custom-field-templates/access`;

// Scripts
export const API_SCRIPTS_LIST = `${API_BASE}/scripts`;

// Tts
export const API_TTS_LIST = `${API_BASE}/tts`;
export const API_TTS_CREATE = `${API_BASE}/tts`;
export const API_TTS_DELETE = `${API_BASE}/tts/:id`;
export const API_TTS_UPDATE = `${API_BASE}/tts/:id`;
export const API_TTS_CHANGE_STATUS = `/v2/tts/change/tts/status`;
export const API_TTS_MULTI_LANGUAGE = `${API_BASE}/tts/multi-language`;
export const API_VOICE_PROFILE      = `${API_BASE}/voice-profile`;
export const API_VOICE_PROFILE_ONE  = `${API_BASE}/voice-profile/one`;
export const API_VOICE_PROFILE_BY_ID = (id) => `${API_BASE}/voice-profile/${id}`;
export const API_TTS_DEMO_QUOTA = `${API_BASE}/tts/demo/quota`;

//TTS Plans
export const API_TTS_PLANS_LIST = `${API_BASE}/tts-plans`;
export const API_TTS_PLANS_CREATE = `${API_BASE}/tts-plans`;
export const API_TTS_PLANS_UPDATE = `${API_BASE}/tts-plans/:id`;

//Demo Account Settings
export const API_DEMO_ACCOUNT_SETTINGS_LIST = `${API_BASE}/demo-account-settings`;
export const API_DEMO_ACCOUNT_SETTINGS_CREATE = `${API_BASE}/demo-account-settings`;
export const API_DEMO_ACCOUNT_SETTINGS_UPDATE = `${API_BASE}/demo-account-settings/:id`;
export const API_DEMO_ACCOUNT_SETTINGS_DELETE = `${API_BASE}/demo-account-settings/:id`;

//TTS Credits
export const API_TTS_CREDITS = `${API_BASE}/tts-credits/:id`;

//AI Agent Voice Credits
export const API_AI_AGENT_CREDITS = `${API_BASE}/ai-agent-credits/:id`;

// User Breaks
export const USER_BREAKS_LIST = `${API_BASE}/user-breaks`;
export const USER_BREAKS_CREATE = `${API_BASE}/user-breaks/create`;
export const USER_BREAKS_EDIT = `${API_BASE}/user-breaks/:id`;
export const USER_BREAKS_ACTIVE = `${API_BASE}/user-breaks/active`;
export const API_AGENT_BREAK_EXCEEDED_STATS = `${API_BASE}/user-breaks/exceeded-stats`;

export const LICENCE_HISTORY_LIST = `${API_BASE}/licence-history`;

export const AGENT_CALL_CONNECT_LIST = `${API_BASE}/agent-call-connect`;


//Flash Message
export const API_FLASH_MESSAGE_LIST = `${API_BASE}/flash-message`;
export const API_FLASH_MESSAGE_CREATE = `${API_BASE}/flash-message/create`;
export const API_FLASH_MESSAGE_EDIT = `${API_BASE}/flash-message`;
export const API_FLASH_MESSAGE_DELETE = `${API_BASE}/flash-message/delete`;

export const API_DASHBOARD_STATS = `${API_BASE}/dashboard-stats`;
export const API_DASHBOARD_OUTBOUND_CAMPAIGNS_STATS = `${API_BASE}/dashboard-stats/outbound-campaigns`;
export const API_DASHBOARD_USER_WISE_CAMPAIGN_SUMMARY_STATS = `${API_BASE}/dashboard-stats/user-wise-campaign-summary`;
export const API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS = `${API_BASE}/dashboard-stats/today-running-campaigns`;
export const API_DASHBOARD_OUTGOING_CALLS_SUMMARY = `${API_BASE}/dashboard-stats/outgoing-calls-summary`;
export const API_DASHBOARD_INCOMING_SUMMARY = `${API_BASE}/dashboard-stats/incoming-summary`;
export const API_DASHBOARD_ANSWERED_UNANSWERED_SUMMARY = `${API_BASE}/dashboard-stats/answered-unanswered-summary`;
export const API_DASHBOARD_DISCONNECTED_CALL_SUMMARY = `${API_BASE}/dashboard-stats/disconnected-call-summary`;
export const API_DASHBOARD_IVR_LISTING = `${API_BASE}/dashboard-stats/ivr-listing`;
export const API_AGENT_CALL_SUMMARY_CARDS = `${API_BASE}/dashboard-stats/agent-call-summary-cards`;
export const API_AGENT_CALL_STATS = `${API_BASE}/dashboard-stats/agent-call-stats`;
export const API_AGENT_PERFORMANCE_REPORT = `${API_BASE}/agent-performance-report`;
export const API_AGENT_SELF_PERIOD_STATS = `${API_BASE}/dashboard-stats/agent-self-period-stats`;
export const API_AGENT_SELF_RANGE_STATS = `${API_BASE}/dashboard-stats/agent-self-range-stats`;

export const API_AGENT_DASHBOARD_CAMPAIGNS = `${API_BASE}/agents/dashboard/active-campaigns/agent-data`;
export const API_AGENT_DASHBOARD_CAMPAIGN_TOGGLE = `${API_BASE}/agents/dashboard/campaigns/toggle`;
export const API_AGENT_DASHBOARD_CALLS = `${API_BASE}/agents/dashboard/agent-calls/:id`;
export const API_AGENT_CALL_LOG_DIAL_NUMBER = `${API_BASE}/agents/dashboard/agent-calls/:callId/dial-number`;
export const API_AGENT_CALL_SUMMARY_REPORT = `${API_BASE}/agents/dashboard/agent-call-summary/:id`;
export const API_TEAM_LEAD_AGENT_STATS = `${API_BASE}/agents/team-lead-stats`;
export const API_TEAM_LEAD_GROUPS = `${API_BASE}/agents/team-lead-groups`;
export const API_TEAM_LEAD_CAMPAIGNS = `${API_BASE}/agents/team-lead-campaigns`;
export const API_TEAM_LEAD_CALLS = `${API_BASE}/agents/team-lead-calls`;

// Live calls (Redis mirror of calls in progress, read through the backend).
// Scope is server-side: super/sub-super admin pass companyId+ccId, company
// roles pass ccId, call-centre admins / team leads / agents pass nothing.
export const API_LIVE_CALLS = `${API_BASE}/live-calls`;
export const API_LIVE_CALLS_COUNTS = `${API_BASE}/live-calls/counts`;
export const API_LIVE_CALLS_SCOPES = `${API_BASE}/live-calls/scopes`;
export const API_LIVE_CALLS_STREAM = `${API_BASE}/live-calls/stream`;
export const API_LIVE_CALL_BY_ID = (id) => `${API_BASE}/live-calls/${encodeURIComponent(id)}`;

export const API_CALLS_CREATE = `${API_BASE}/calls`;

//notification
export const API_NOTIFICATION_LIST = `${API_BASE}/notifications`;
export const API_NOTIFICATION_CREATE = `${API_BASE}/notifications/create`;
export const API_NOTIFICATION_EDIT = `${API_BASE}/notifications/update/:id`;
export const API_NOTIFICATION_DELETE = `${API_BASE}/notifications/delete`;
export const API_NOTIFICATION_SINGLE = `${API_BASE}/notifications/:id`;
export const API_NOTIFICATION_ASSIGN_TO_AGENT = `${API_BASE}/notifications/assign-to-agents/`;
export const API_NOTIFICATION_ASSIGNED_TO_AGENT = `${API_BASE}/notifications/assigned-to-agents/`;
export const API_NOTIFICATION_UNASSIGN_FROM_AGENT = `${API_BASE}/notifications/remove-from-agents/`;
export const API_NOTIFICATION_ASSIGN_TO_USER = `${API_BASE}/notifications/assign-to-users/`;
export const API_NOTIFICATION_ASSIGNED_TO_USER = `${API_BASE}/notifications/assigned-to-users/`;
export const API_NOTIFICATION_UNASSIGN_FROM_USER = `${API_BASE}/notifications/remove-from-users/`;
export const API_NOTIFICATION_MARK_READ = `${API_BASE}/notifications/mark-read`;
export const API_NOTIFICATION_MARK_ALL_READ = `${API_BASE}/notifications/mark-all-read`;
export const API_NOTIFICATION_MARK_UNREAD = `${API_BASE}/notifications/mark-unread`;


// Call Scripts
export const API_CALL_SCRIPT_LIST   = `${API_BASE}/scripts`;
export const API_CALL_SCRIPT_CREATE = `${API_BASE}/scripts/create`;
export const API_CALL_SCRIPT_EDIT   = `${API_BASE}/scripts/update/:id`;
export const API_CALL_SCRIPT_DELETE = `${API_BASE}/scripts/delete`;
export const API_CALL_SCRIPT_SINGLE = `${API_BASE}/scripts/:id`;
export const API_CALL_SCRIPT_SET_DEFAULT = `${API_BASE}/scripts/:id/set-default`;
export const API_CALL_SCRIPT_BY_CONTEXT = `${API_BASE}/scripts/by-context`;



export const API_DISPOSITION_LIST = `${API_BASE}/disposition-forms`;
export const API_DISPOSITION_GET_ONE = `${API_BASE}/disposition-forms/:id`;
export const API_DISPOSITION_CREATE = `${API_BASE}/disposition-forms`;
export const API_DISPOSITION_UPDATE = `${API_BASE}/disposition-forms/:id`;
export const API_DISPOSITION_DELETE = `${API_BASE}/disposition-forms/delete`;
export const API_DISPOSITION_SET_DEFAULT = `${API_BASE}/disposition-forms/:id/set-default`;
export const API_DISPOSITION_SET_SYSTEM_DEFAULT = `${API_BASE}/disposition-forms/:id/set-system-default`;
export const API_DISPOSITION_TIMING_DEFAULTS = `${API_BASE}/disposition-forms/timing-defaults`;

export const API_DISPOSITION_FORM_DATA_CREATE = `${API_BASE}/disposition-form-data/`;
export const API_CALL_QUALITY_FORM = `${API_BASE}/call-quality-feedback/form`;
export const API_CALL_QUALITY_PENDING = `${API_BASE}/call-quality-feedback/pending`;
export const API_CALL_QUALITY_SUBMIT = `${API_BASE}/call-quality-feedback/:id/submit`;
export const API_CALL_QUALITY_SKIP = `${API_BASE}/call-quality-feedback/:id/skip`;
export const API_CALL_QUALITY_SUBMISSIONS = `${API_BASE}/call-quality-feedback/submissions`;
export const API_CALL_QUALITY_SUBMISSIONS_EXPORT = `${API_BASE}/call-quality-feedback/submissions/export`;
export const API_DISPOSITION_FORM_DATA_UPDATE = `${API_BASE}/disposition-form-data/:id`;
export const API_DISPOSITION_BY_CONTEXT = `${API_BASE}/disposition-forms/by-context`;

// Disposition wrap-up timing lifecycle.
export const API_DISPOSITION_WRAP_UP_START = `${API_BASE}/disposition-form-data/wrap-up/start`;
export const API_DISPOSITION_WRAP_UP_COMPLETE = `${API_BASE}/disposition-form-data/wrap-up/complete`;
export const API_DISPOSITION_WRAP_UP_ABANDON = `${API_BASE}/disposition-form-data/wrap-up/abandon`;
export const API_DISPOSITION_WRAP_UP_HOLD = `${API_BASE}/disposition-form-data/wrap-up/hold`;
export const API_DISPOSITION_WRAP_UP_RELEASE = `${API_BASE}/disposition-form-data/wrap-up/release`;

export const API_DISPOSITION_PENDING_LIST = `${API_BASE}/disposition-form-data/pending`;
export const API_DISPOSITION_PENDING_SAVE = `${API_BASE}/disposition-form-data/pending`;
export const API_DISPOSITION_PENDING_RESOLVE = `${API_BASE}/disposition-form-data/pending/resolve`;
export const API_DISPOSITION_PENDING_BY_AGENTS = `${API_BASE}/disposition-form-data/pending/by-agents`;

export const API_CUSTOMER_DISPOSITION_HISTORY = `${API_BASE}/disposition-form-data/customer-history`;
export const API_DISPOSITION_BY_CALL = `${API_BASE}/disposition-form-data/by-call`;
export const API_DISPOSITIONS_BY_CALLS = `${API_BASE}/disposition-form-data/by-calls`;

export const API_DISPOSITION_FOLLOW_UPS_LIST = `${API_BASE}/disposition-follow-ups`;
export const API_DISPOSITION_FOLLOW_UP_STATUS = `${API_BASE}/disposition-follow-ups/:id/status`;
export const API_DISPOSITION_FOLLOW_UP_NOTIFICATIONS = `${API_BASE}/disposition-follow-ups/notifications`;
export const API_DISPOSITION_FOLLOW_UP_COMPLETE_BY_CALL = `${API_BASE}/disposition-follow-ups/:id/complete-by-call`;
export const API_DISPOSITION_FOLLOW_UP_DIAL_NUMBER = `${API_BASE}/disposition-follow-ups/:id/dial-number`;

export const API_VOICEMAILS_LIST = `${API_BASE}/voicemails`;
export const API_VOICEMAILS_AUDIO = `${API_BASE}/voicemails/:id/audio`;

export const API_CDR_MEDIA_MODE = `${API_BASE}/cdr-media/mode`;
export const API_VOICEMAILS_DETAILS = `${API_BASE}/voicemails/details`;
export const API_RECORDINGS_DETAILS = `${API_BASE}/recordings/details`;
export const API_RECORDINGS_AUDIO = `${API_BASE}/recordings/:id/audio`;

// Agent Leads
export const API_AGENT_LEADS_LIST = `${API_BASE}/agent-leads`;
export const API_AGENT_LEAD_HISTORY = `${API_BASE}/agent-lead-history`;
export const API_AGENT_LEADS_BALANCE = `${API_BASE}/agent-leads/balance`;
export const API_AGENT_LEADS_CREATE = `${API_BASE}/agent-leads`;
export const API_AGENT_LEADS_GET_ONE = `${API_BASE}/agent-leads/:id`;
export const API_AGENT_LEADS_DELETE = `${API_BASE}/agent-leads/:id/delete`;
export const API_AGENT_LEADS_TRANSFER = `${API_BASE}/agent-leads/:id/transfer`;
export const API_AGENT_LEADS_TRANSFER_RECIPIENTS = `${API_BASE}/agent-leads/:id/transfer-recipients`;
export const API_AGENT_LEADS_TITLE = `${API_BASE}/agent-leads/:id/title`;
export const API_AGENT_LEADS_ITEMS_DELETE = `${API_BASE}/agent-leads/:id/items/delete`;
export const API_AGENT_LEADS_MARK_COMPLETE = `${API_BASE}/agent-leads/:id/complete`;
export const API_AGENT_LEADS_MY = `${API_BASE}/agent-leads/my/leads`;
export const API_AGENT_LEADS_COMPLETE = `${API_BASE}/agent-leads/items/:itemId/complete`;

export const API_AGENT_LEADS_ITEMS = `${API_BASE}/agent-leads/:id/items`;
export const API_AGENT_LEADS_MY_ASSIGNMENTS = `${API_BASE}/agent-leads/my/assignments`;
export const API_AGENT_LEADS_MY_ITEMS = `${API_BASE}/agent-leads/my/assignments/:assignmentId/items`;
export const API_AGENT_LEADS_MY_PENDING_COUNT = `${API_BASE}/agent-leads/my/pending-count`;

export const API_SYSTEM_MONITORING_STATS = `${API_BASE}/system-monitor`;
export const API_SYSTEM_HEALTH_ALERTS = `${API_BASE}/system-monitor/health-alerts`;

export const API_AGENT_CALL_STATUS_UPDATE = `${API_BASE}/agents/call-status`;

export const API_AGENT_MY_START_SCREEN = `${API_BASE}/agents/me/start-screen`;

export const API_AGENT_MY_DASHBOARD_LAYOUT = `${API_BASE}/agents/me/dashboard-layout`;

export const API_USER_PANEL_CUSTOMIZATION_ME = `${API_BASE}/user-panel-customization/me`;
export const API_USER_APPEARANCE_PREFERENCES_ME = `${API_BASE}/user-appearance-preferences/me`;

export const API_CALL_CENTER_UPDATE_CHANNEL_LICENCE = `${API_BASE}/agents/update-channel-licence`;

export const API_CREDIT_HISTORY_SUMMARY_OF_SPECIFIC_COMPANY = `${API_BASE}/credits/summary`;

export const API_LIST_OF_API_USERS = `${API_BASE}/api-users`;

export const API_API_USERS_ACTIVITY_LOGS = `${API_BASE}/api-users/activity-logs`;

export const API_BACKEND_LOGS = `${API_BASE}/logs/`;

export const API_HANGUP_CAUSES = `${API_BASE}/hangup-cause-codes`;
export const API_HANGUP_PROMPT_MAPPING = `${API_BASE}/hangup-cause-prompt-mapping`;

export const API_CERTS_EXPIRY_CHECKER = `${API_BASE}/certs-expiry/`

// Blacklist / DND (v2 routes)
export const API_DND_ADD = `/v2/dnd/addDND`;
export const API_DND_LIST = `/v2/dnd/`;
export const API_BLACKLIST_ADD = `/v2/blacklist`;
export const API_BLACKLIST_LIST = (userId) => `/v2/blacklist/${userId}`;
export const API_BLACKLIST_DELETE = (id) => `/v2/blacklist/${id}`;
export const API_SEARCH_BLACKLIST_DND = `/v2/dnd/search/Blacklist/DND`;
export const API_BLACKLIST_BULK_UPLOAD = `/v2/blacklist/blistupload`;
export const API_BLACKLIST_REMOVE_CALL_CENTRE = (id) => `/v2/blacklist/${id}/remove-call-centre`;

// Agent Activity
export const API_AGENT_ACTIVITY_LOG_BULK = `${API_BASE}/agent-activity-logs`;
export const API_AGENT_ACTIVITY_LOG_LIST = `${API_BASE}/agent-activity-logs`;
export const API_WEBRTC_SIP_LOG_BULK = `${API_BASE}/webrtc-sip-logs`;
// Agent / team-lead header speed test (small GET download + POST upload).
export const API_NETWORK_SPEED = `${API_BASE}/network-speed`;
export const API_WEBRTC_SIP_TRACE_SESSIONS = `${API_BASE}/webrtc-sip-logs/sessions`;
export const API_WEBRTC_SIP_TRACE_EVENTS = `${API_BASE}/webrtc-sip-logs/events`;
export const API_WEBRTC_SIP_TRACE_FAILURES = `${API_BASE}/webrtc-sip-logs/failures`;

export const API_SESSION_REPLAY_START = `${API_BASE}/session-replay/sessions/start`;
export const API_SESSION_REPLAY_SESSIONS = `${API_BASE}/session-replay/sessions`;
export const API_SESSION_REPLAY_DELETE = `${API_BASE}/session-replay/sessions/delete`;
export const API_SESSION_REPLAY_BATCH = (sessionId) =>
  `${API_BASE}/session-replay/sessions/${sessionId}/batch`;
export const API_SESSION_REPLAY_END = (sessionId) =>
  `${API_BASE}/session-replay/sessions/${sessionId}/end`;
export const API_SESSION_REPLAY_DETAIL = (sessionId) =>
  `${API_BASE}/session-replay/sessions/${sessionId}`;
export const API_SESSION_REPLAY_CHUNKS_META = (sessionId) =>
  `${API_BASE}/session-replay/sessions/${sessionId}/chunks/meta`;
export const API_SESSION_REPLAY_CHUNKS = (sessionId, from, to) =>
  `${API_BASE}/session-replay/sessions/${sessionId}/chunks?from=${from}&to=${to}`;
export const API_SESSION_REPLAY_EVENTS = (sessionId) =>
  `${API_BASE}/session-replay/sessions/${sessionId}/events`;
export const API_SESSION_REPLAY_ANALYTICS_SCREEN_USAGE = `${API_BASE}/session-replay/analytics/screen-usage`;
export const API_SESSION_REPLAY_ANALYTICS_HEATMAP = `${API_BASE}/session-replay/analytics/heatmap`;
export const API_SESSION_REPLAY_ANALYTICS_RAGE_CLICKS = `${API_BASE}/session-replay/analytics/rage-clicks`;
export const API_SESSION_REPLAY_ANALYTICS_INSIGHTS = `${API_BASE}/session-replay/analytics/insights`;
export const API_SESSION_REPLAY_RECORDING_ME = `${API_BASE}/session-replay/recording-config/me`;
export const API_SESSION_REPLAY_RECORDING_CONFIG = `${API_BASE}/session-replay/recording-config`;

export const API_RELEASE_CENTER_LIST = `${API_BASE}/release-center`;
export const API_RELEASE_CENTER_STATS = `${API_BASE}/release-center/stats`;
export const API_RELEASE_CENTER_TAGS = `${API_BASE}/release-center/tags`;
export const API_RELEASE_CENTER_COMPARE = `${API_BASE}/release-center/compare`;
export const API_RELEASE_CENTER_SINGLE = `${API_BASE}/release-center/:id`;
export const API_RELEASE_CENTER_CREATE = `${API_BASE}/release-center`;
export const API_RELEASE_CENTER_UPDATE = `${API_BASE}/release-center/:id`;
export const API_RELEASE_CENTER_PUBLISH = `${API_BASE}/release-center/:id/publish`;
export const API_RELEASE_CENTER_PIN = `${API_BASE}/release-center/:id/pin`;
export const API_RELEASE_CENTER_DISABLE = `${API_BASE}/release-center/:id/disable`;

export const API_USERS_CHECK_AVAILABILITY = `${API_BASE}/users/check-availability`;

export const API_AGENTS_CHECK_AVAILABILITY = `${API_BASE}/agents/check-availability`;
export const API_AGENT_CREATE_LICENCE = `${API_BASE}/agents/licence`;